import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useEventContext } from "../../context/EventContext";
import { useLocaleContext } from "../../context/LocaleContext";
import { useShopContext } from "../../context/ShopContext";
import { useUserContext } from "../../context/UserContext";
import { ModalContextProvider, useModalContext } from "../../context/ModalContext";
import { useWindowResize } from "../../hooks/useWindowResize";
import { TYPE_SHOP } from "../../constants/page-types";
import { capitalizer } from "../../../../cp/utils";
import { endingPoints } from "../../helpers/prizes-shop";
import PrizeCard from "./PrizeCard";
import CPaginator from "../../components/UI/CPaginator";
import UserPrizesModal from "./UserPrizesModal";
import UIButton from "../../../../globalComponents/UIComponents/UIButton";

import './style.scss';

const getPerPage = (windowWidth) => {
    let perPage = 12;

    const widths = {
        '1560': 8,
        '1080': 6,
        '860': 4,
    }

    Object.keys(widths).sort((a, b) => parseInt(b) - parseInt(a)).forEach(width => {
        if (parseInt(windowWidth) <= parseInt(width)) {
            perPage = widths[width]
        }
    })

    return perPage;
}

export default ({ }) => {
    const { event, pages } = useEventContext();
    const { user } = useUserContext();
    const { activePrizes, userBalance, loadingShopData } = useShopContext();
    const $locale = useLocaleContext();
    const { pathname } = useLocation();

    const [perPage, setPerPage] = useState(getPerPage());
    const [page, setPage] = useState(0);

    const currentPageSettings = pathname.includes(TYPE_SHOP)
        ? pages.find(({ type }) => type === TYPE_SHOP)?.settings
        : null;

    useWindowResize(({ width }) => {
        setPerPage(getPerPage(width));
        setPage(0);
    }, ['width']);

    if (!event.moduleShop?.enabled) return null;

    return (
        <ModalContextProvider>
            <section className={"page-block prizes-shop-block"}>
                <div className="page-block-header">
                    {!!currentPageSettings && currentPageSettings?.showTitle && (
                        <h1
                            className="page-block-title"
                            style={{
                                fontSize: !!currentPageSettings?.titleSize ? currentPageSettings?.titleSize : '',
                                fontWeight: currentPageSettings?.titleBold ? 'bold' : 'normal',
                            }}
                        >
                            {currentPageSettings[`title${capitalizer($locale.name)}`]}
                        </h1>
                    )}
                    {!currentPageSettings && (
                        <h1 className="page-block-title">
                            {$locale.get("title.page.shop")}
                        </h1>
                    )}
                </div>
                <UserBalance $locale={$locale} user={!!user} userBalance={userBalance} event={event} />
                <div className="prizes-container">
                    {activePrizes.slice(page * perPage, page * perPage + perPage).map(prize => <PrizeCard
                        key={prize.id}
                        prize={prize}
                        user={!!user}
                        $locale={$locale}
                        userBalance={userBalance}
                        endingPoints={endingPoints}
                        loadingShopData={loadingShopData}
                    />
                    )}
                </div>
                {activePrizes.length > perPage &&
                    <CPaginator
                        currentPage={page}
                        perPage={perPage}
                        total={activePrizes.length}
                        onChangePage={page => setPage(page)}
                    />
                }
            </section>
        </ModalContextProvider>
    );
}

const UserBalance = ({ $locale, user, userBalance, event }) => {
    const { renderModal } = useModalContext();

    if (!user || userBalance === null) return null;

    return <div className="user-balance">
        <h2>
            {$locale.get("shop.balance")} {userBalance.toLocaleString('ru-RU')} {String($locale.get('common.point')).toLowerCase() + endingPoints($locale.name, userBalance)}
        </h2>
        <UIButton
            color="primary"
            size="large"
            onClick={() => renderModal(UserPrizesModal, { event, $locale, lockPageScroll: false, })}
        >
            {$locale.get('shop.myPrizes')}
        </UIButton>
    </div>
}
